/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import WeekPicker from "./WeekPicker";
import {
  Box,
  Button,
  Typography,
  Grid,
  TableRow,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
} from "@material-ui/core/";
import { makeStyles } from "@material-ui/core/styles";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import StopIcon from "@material-ui/icons/Stop";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import { getWorkersByMgr } from "services";
import { getEndOfWeek, isEmptyObject, jobTypeITContractor } from "utils";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { MANAGE_TIMESHEET } from "navigation/CONSTANTS";
import { useHistory } from "react-router-dom";
import SectionHead from "../../../src/components/SectionHead";
import { properCase } from "utils";
import {
  getWorkerIMTimeRole,
} from "services/workerSchedule";
const useStyles = makeStyles((theme) => ({
  selectedWorker: {
    backgroundColor: theme.palette.action.selected,
    textAlign: "center",
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.primary.main,
  },
  TSApprovedStatus: {
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    color: "#388e3c",
  },
  tansactional: {
    color: "#1B75BC",
  },
  nonTransactional: {
    color: "#00A88E",
  },
  project: {
    color: "#6DCFF6",
  },
  buildingMoves: {
    color: "#3C5772",
  },
  meal: {
    color: "#58595B",
  },
  leave: {
    color: "#58595B",
  },
}));

const Controls = (props) => {
  const {
    onWeekChange,
    onWorkerChange,
    setLoading,
    onChangeSelections,
    selectedDate,
    removeEvents,
    value,
    locationProps,
    approveFlag,
    clickedApproval,
    nonew,
    workerName,
    timesheetStatus,
    deleted,
    incompletePunchCount,
    activityGroupTotals,
  } = props;
  // console.log("activityGroupTotals:", activityGroupTotals);
  const classes = useStyles();
  const [workers, setWorkers] = useState([]);
  const [selectedWorker, setSelectedWorker] = useState(
    locationProps && locationProps.selectedWorker
  );
  const { user } = useSelector((state) => state.user.auth);
  const [districts, setDistricts] = useState([]);
  const history = useHistory();
  const { selectedWeekOnReview } = useSelector((state) => state.appConfig);
  const [buildings, setBuildings] = useState([]);
  const [disabled, setDisabled] = React.useState(false);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [imtRole, setImtRole] = useState("");
  const [imtimeRole, setImtimeRole] = useState(true);
  const { selectedManagerForApproval } = useSelector(
    (state) => state.appConfig
  );

  const IMTimeRole = useSelector((state) => state.user.imtRole.userRole || null);
  const activityGroupClass = (activityGroup) => {
    switch (activityGroup) {
      case "transactional":
        return classes.tansactional;

      case "nonTransactional":
        return classes.nonTransactional;

      case "project":
        return classes.project;

      case "buildingMoves":
        return classes.buildingMoves;

      case "meal":
        return classes.meal;

      case "leave":
        return classes.leave;

      default:
        return {};
    }
  };

  const activityGroupText = (activityGroup) => {
    switch (activityGroup) {
      case "transactional":
        return "Transactional";

      case "nonTransactional":
        return "Non-Transactional";

      case "project":
        return "Project";

      case "buildingMoves":
        return "Building Moves";

      case "meal":
        return "Meal";

      case "leave":
        return "Leave";

      default:
        return "";
    }
  };

  console.log("ACTIVITY TOTALS ", activityGroupTotals);

  const activityGroupIcon = (activityGroupTotals, activityGroup) => {
    const activityGroupIconJsx = (
      <Tooltip
        title={
          <Typography variant="subtitle2">
            {activityGroupText(activityGroup)}
          </Typography>
        }
      >
        <Button
          size="small"
          style={{ cursor: "default", textTransform: "none" }}
          disableRipple
        >
          <StopIcon
            className={activityGroupClass(activityGroup)}
            fontSize="35"
          />
          <Typography
            variant="h6"
            style={{ marginLeft: "0.8rem", fontSize: 17 }}
          >
            {activityGroupTotals[activityGroup] + " Hrs"}
          </Typography>
        </Button>
      </Tooltip>
    );

    if (activityGroupTotals[activityGroup] > 0) {
      return activityGroupIconJsx;
    } else {
      return null;
    }
  };

  useEffect(() => { 
    if(IMTimeRole?.role){
      if(IMTimeRole?.role === "Support"){
        setImtimeRole(true);
      }
      else{
        setImtimeRole(false)
      }
      console.log("IMTimeRole", IMTimeRole?.role)
    }
  },[IMTimeRole])

  useEffect(() => {
    const weekEnd = getEndOfWeek(selectedDate);
    onChangeSelections({
      weekStart: selectedDate,
      weekEnd,
      selectedWorker,
    });
  }, [selectedDate, selectedWorker]);

  useEffect(() => {
    if (user && user.workerId && selectedWorker) {
      getWorkerIMTimeRole(user.workerId).then((logindata) => {
        setImtRole(logindata.role);
        let userWorkerId = selectedWorker.managerId;
        setLoading(true);
        getWorkersByMgr(userWorkerId)
          .then((data) => {
            console.log(`getWorkersByMgr for ${user.workerId} = data=`, data);
            let active = [];
            //When user directly navigates to add-timesheet, it should render, if data exists then show that otherwise empty options in worker
            if (data !== false) {
              for (let i = 0; i < data.workers.length; i++) {
                  const jobType = data.workers[i].jobType ? data.workers[i].jobType : "";
                if (data.workers[i].isActiveWorker && jobType !== jobTypeITContractor) {
                  active.push(data.workers[i]);
                }
              }
            }
            //sorting the workers name in workers dropdown
            active.sort((a, b) =>
              a.name.toLowerCase() > b.name.toLowerCase()
                ? 1
                : a.name.toLowerCase() === b.name.toLowerCase()
                  ? a.workerId > b.workerId
                    ? 1
                    : -1
                  : -1
            );

            let delegateFor = user?.delegateFor;
            if ((!(delegateFor && userWorkerId &&
              delegateFor.includes(userWorkerId))) &&
              ((logindata.role && logindata.role !== "" && logindata.role.toLowerCase() === "supervisor" && user.workerId !== userWorkerId)
                || (!logindata.role && user && user.isApprover && user.workerId !== userWorkerId))) {

              active = active.length > 0 && active.filter(item => item.approvingManager && item.approvingManager.includes(user.workerId))
            }
            setWorkers(active);
            setLoading(false);
            // dispatch(setAllMyWorkers(data.workers));
          })
          .catch((err) => {
            // setLoading(false);
            console.error("BulkEntry: Err in getWorkerByMgr Response: ", err);
          });
      });
    }
  }, [user, selectedWorker]);

  function handleApprove() {
    clickedApproval();
  }
  useEffect(() => {
    if (
      timesheetStatus === "pending" &&
      selectedDate >= moment(new Date()).startOf("week").subtract(2, "weeks")
    ) {
      setDisabled(false);
    } else {
      handleDisableForApprove(approveFlag, deleted);
    }
  }, [approveFlag, deleted, timesheetStatus]);

  const handleDisableForApprove = (approveFlag, deleted) => {
    if (approveFlag === false && deleted === false) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  };

  return (
    <Box
      p={2}
      display="flex"
      flexDirection="row"
      style={{ gap: 16 }}
      alignItems="stretch"
    >
      <WeekPicker
        size="small"
        variant="outlined"
        weekChangeHandler={(date) => {
          if (onWeekChange) onWeekChange(date);
        }}
        startDate={value}
        renderInput={(params) => (
          <TextField
            {...params}
            label={properCase(t("pgHome.lblReportWeek"))}
            size="small"
            variant="outlined"
          />
        )}
        maxDate={moment().add(1, "years")}
        minDate={moment().subtract(3, "months").startOf("month")}
      />
      <Autocomplete
        // disablePortal
        id="combo-box-demo"
        options={workers}
        getOptionLabel={(option) =>
          option.name ? option.name + " (" + option.workerId + ")" : ""
        }
        style={{ minWidth: 200, height: 10 }}
        value={selectedWorker}
        // defaultValue={{ value: selectedWorker }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        renderInput={(params) => (
          <TextField
            {...params}
            label={properCase(t("other.lblWorker"))}
            size="small"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
            }}
          />
        )}
        onChange={(event, newValue) => {
          if (newValue) {
            if (newValue.country !== selectedWorker.country) {
              setSelectedWorker(newValue);
            }
            if (newValue.country === selectedWorker.country) {
              setSelectedWorker(newValue);
            }
          }
        }}
        onInputChange={(event, newValue) => {
          if (!newValue) {
            setSelectedWorker("");
            removeEvents();
          }
        }}
      />
      {/* <SectionHead  name="ABCD" /> */}

      {workerName && (
        <Typography variant="subtitle1" className={classes.selectedWorker}>
          {workerName}
        </Typography>
      )}

      {isEmptyObject(activityGroupTotals) || activityGroupTotals === undefined
        ? null
        : Object.keys(activityGroupTotals).map((activityGroup) =>
          activityGroupIcon(activityGroupTotals, activityGroup)
        )}

      <Box style={{ flexGrow: 1 }} />
      <Button
        variant="outlined"
        color="primary"
        disableElevation
        onClick={() => {
          history.push(MANAGE_TIMESHEET, { isTimesheetView: true });
        }}
      >
        {properCase(t("other.tlBack"))}
      </Button>
      {console.table(
        "[timesheet status, nonew, approveFlag deleted disabled]",
        timesheetStatus,
        nonew,
        approveFlag,
        deleted,
        !approveFlag || !deleted
      )}
      {timesheetStatus === "approved" && nonew ? (
        // <Button disableElevation style={{ color: "#388e3c" }}>
        //   {console.log("approve button", approveFlag)}
        //   Approved
        // </Button>
        <Typography variant="button" className={classes.TSApprovedStatus}>
          {properCase(t("other.lblApproved"))}
        </Typography>
      ) : (
        <Button
          variant="contained"
          color="primary"
          disableElevation
          disabled={disabled || imtimeRole}
          onClick={handleApprove}
        >
          {console.log("olap pla", disabled || incompletePunchCount != 0)}
          {properCase(t("pgReview.btnApprove"))}
        </Button>
      )}
    </Box>
  );
};

export default Controls;
